// src/theme/theme.js
import { createTheme, responsiveFontSizes } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#0c2342', // color objeto: azul
    },
    secondary: {
      main: '#279a53', // color objeto: verde
      // light: '#93BF38',
      light: '#93c032',
      dark: '#1c7b3f',
    },
    text: {
      primary: '#1b1c37', // texto (azul oscuro)
      secondary: '#6a6a6a', // texto (gris)
      white: '#ffffff', // text (blanco)
      darkBlue: '#00070A',
      deepGreen: '#282B1B',
      forestGreen: '#283B28',
      mutedTeal: '#4E6A5B',
      ivory: '#E0DED1',
      mustard: '#A68D4A',
    },
    background: {
      default: '#ffffff', // fondo (blanco)
      paper: '#ffffff', // fondo (blanco)
      gray_light: '#e6e6e6', // fondo (gris light)
      black: '#000000',
      chip: '#c1f8ab',
      var_chip_light: '#fafafaa3',
    },
    status: {
      noProcess: '#d8382e',
      inProcess: '#f2994a',
      finished: '#6fcf97',
    },
  },
  typography: {
    fontFamily:
      "Montserrat, 'Avenir Next', 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif",
    h1: {
      fontWeight: 600,
      fontSize: '2.2rem',
    },

    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },

    h3: {
      fontWeight: 500,
      fontSize: '1.8rem',
    },

    h4: {
      fontWeight: 500,
      fontSize: '1.5rem',
    },

    body1: {
      fontSize: '1rem',
    },

    body2: {
      fontSize: '0.9rem',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        color: 'primary',
      },
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
  },
})

export default responsiveFontSizes(theme)
